import React, { memo } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatCurrency } from "../../../utils/formatCurrency";
import { disabledScrollTextBoxNumber } from "../../../utils/disabledScrollTextBoxNumber";
import {
  potensiTingkatKeparahanItem,
  potensiKejadianItem,
} from "../../../constants/tingkatKeparahan";

const ActualImpact = ({
  input,
  setInput,
  loading,
  setSnackbar,
  checkPotensi,
  fetchTingkatKeparahan,
  readOnly = false,
}) => {
  // Void functions
  const onChangeTitle = (index, value) => {
    setInput((prev) => {
      const newTitle = [...prev.actualImpactSelected.title];
      const newType = [...prev.actualImpactSelected.type];
      newTitle[index - 1] = value;
      newType[index - 1] = null;
      return {
        ...prev,
        actualImpactSelected: { title: newTitle, type: newType },
      };
    });
  };

  const onChangeType = (index, value) => {
    setInput((prev) => {
      const newType = [...prev.actualImpactSelected.type];
      newType[index - 1] = value;
      return {
        ...prev,
        actualImpactSelected: { ...prev.actualImpactSelected, type: newType },
      };
    });
  };

  const onPressAddButton = (index) => {
    try {
      // Get selected data and list added
      index -= 1;
      const hasType = index < 2; // Health and safety, Environment
      const selectedTitle = input.actualImpactSelected.title[index];
      const selectedType = hasType
        ? input.actualImpactSelected.type[index]
        : null;

      // Null validations
      if (!selectedTitle) throw "Choose Detail!";
      if (hasType && !selectedType) throw "Choose Detail and Type first!";

      // Duplicate validations
      let isExists = false;
      switch (index) {
        case 0:
          isExists = input.listDetailActualImpactContent.find(
            (item) =>
              item.detailContentActualImpactId ==
                selectedTitle.detailContentActualImpactId &&
              item.idTipePekerja == selectedType.id
          );
          break;
        case 1:
          isExists = input.listDetailActualImpactContent.find(
            (item) =>
              item.detailContentActualImpactId ==
                selectedType.idDataMstDtlEstimateImpactContent &&
              item.actualImpactContentItemId == selectedType.id
          );
          break;
        default:
          isExists = input.listDetailActualImpactContent.find(
            (item) =>
              item.detailContentActualImpactId ==
              selectedTitle.detailContentActualImpactId
          );
          break;
      }
      if (isExists)
        throw "Data sudah pernah diinputkan, silahkan memilih tipe yang berbeda!";

      // Adding object to aray
      let obj = { ...selectedTitle };
      switch (index) {
        case 0:
          obj.idTipePekerja = selectedType.id;
          obj.tipePekerja = selectedType.name;
          break;
        case 1:
          obj.actualImpactContentItemId = selectedType.id;
          obj.actualImpactContentItemName = selectedType.itemName;
          obj.konversiSatuan = selectedType.valueConvertion;
          break;
      }
      const newList = calculateSeverityByDeathCount([
        ...input.listDetailActualImpactContent,
        obj,
      ]);
      const potensi = checkPotensi(newList);
      setInput((prev) => {
        const newTitle = [...prev.actualImpactSelected.title];
        const newType = [...prev.actualImpactSelected.type];
        newTitle[index] = null;
        newType[index] = null;
        return {
          ...prev,
          ...potensi,
          listDetailActualImpactContent: newList,
          actualImpactSelected: { title: newTitle, type: newType },
        };
      });
    } catch (message) {
      setSnackbar({
        isOpen: true,
        type: "warning",
        message,
      });
    }
  };

  const onChangeInput = (type, value, field) => {
    // FIND INDEXES
    const indexFieldInArray = input.listDetailActualImpactContent.findIndex(
      (o) =>
        o.actualImpactContentItemId == field.actualImpactContentItemId &&
        o.idTipePekerja == field.idTipePekerja &&
        o.detailContentActualImpactId == field.detailContentActualImpactId
    );
    const indexTotalReleaseProductInArray =
      input.listDetailActualImpactContent.findIndex(
        (o) => o.detailContentActualImpactId == 17
      );
    const indexTotalAssetInArray =
      input.listDetailActualImpactContent.findIndex(
        (o) => o.detailContentActualImpactId == 18
      );

    let newList = [...input.listDetailActualImpactContent];
    let potensi = checkPotensi(newList);
    switch (type) {
      case "jumlahOrNilaiKerugian":
        value = value.replaceAll(",", ".");
        if (field.detailActualImpactId == 5) {
          //value = value.replaceAll(".", "");
        }
        if (value > 99999999.99) {
          value = 99999999.99;
        }
        if (value.length > 11) {
          value = value.substring(0, 11);
        }
        if (Number(value) < 0) value = 0;
        newList[indexFieldInArray].jumlahOrNilaiKerugian = value;
        newList[indexFieldInArray].nilaiKonversi =
          parseFloat(value) *
          parseFloat(newList[indexFieldInArray].konversiSatuan);

        if (isNaN(parseFloat(newList[indexFieldInArray].nilaiKonversi)))
          newList[indexFieldInArray].nilaiKonversi = 0;

        if (field.isByValue) {
          fetchTingkatKeparahan(
            {
              detailActualImpactId: field.detailActualImpactId,
              value,
              totalFinancialImpactValue:
                +getTotalReleaseProduct(newList).jumlahOrNilaiKerugian +
                getTotalAssetAndEquipment(newList).jumlahOrNilaiKerugian,
            },
            (res) => {
              // Insert severity to object
              newList[indexFieldInArray].tingkatKeparahan =
                res[0].tingkatKeparahan;
              newList[indexTotalReleaseProductInArray].tingkatKeparahan =
                res[1].tingkatKeparahan;
              newList[indexTotalAssetInArray].tingkatKeparahan =
                res[1].tingkatKeparahan;
              potensi = checkPotensi(newList);
              // NEED TO SET INPUT BECAUSE OF DELAY
              setInput((prev) => ({
                ...prev,
                ...potensi,
                listDetailActualImpactContent: newList,
              }));
            }
          );
        } else if (field.detailContentActualImpactId === 1) {
          newList = calculateSeverityByDeathCount(newList);
          potensi = checkPotensi(newList);
        }
        break;
      case "keterangan":
        newList[indexFieldInArray].keterangan = value;
        break;
      case "Nilai / Satuan Volume":
        value = value.replaceAll(",", ".");
        if (value > 99.99) {
          value = 99.99;
        }
        if (value.length > 4) {
          value = value.substring(0, 4);
        }
        newList[indexFieldInArray].konversiSatuan = value;
        newList[indexFieldInArray].nilaiKonversi =
          parseFloat(parseInt(value)) *
          parseFloat(newList[indexFieldInArray].jumlahOrNilaiKerugian);

        let tmpJmlNilaiKerugian = parseFloat(
          newList[indexFieldInArray].jumlahOrNilaiKerugian
        ).toFixed(2);

        if (field.isByValue) {
          fetchTingkatKeparahan(
            {
              detailEstimateImpactId: field.detailEstimateImpactId,
              tmpJmlNilaiKerugian,
              totalFinancialImpactValue:
                +getTotalReleaseProduct(newList).jumlahOrNilaiKerugian +
                getTotalAssetAndEquipment(newList).jumlahOrNilaiKerugian,
            },
            (res) => {
              // Insert severity to object
              newList[indexFieldInArray].tingkatKeparahan =
                res[0].tingkatKeparahan;
              newList[indexTotalReleaseProductInArray].tingkatKeparahan =
                res[1].tingkatKeparahan;
              newList[indexTotalAssetInArray].tingkatKeparahan =
                res[1].tingkatKeparahan;
              potensi = checkPotensi(newList);
              // NEED TO SET INPUT BECAUSE OF DELAY
              setInput((prev) => ({
                ...prev,
                ...potensi,
                listDetailEstimateContent: newList,
              }));
            }
          );
        } else if (field.detailContentEstimateImpactId === 1) {
          newList = calculateSeverityByDeathCount(newList);
          potensi = checkPotensi(newList);
        }

        break;
    }
    setInput((prev) => ({
      ...prev,
      ...potensi,
      listDetailActualImpactContent: newList,
    }));
  };

  const onPressRemoveButton = (field) => {
    const indexFieldInArray = input.listDetailActualImpactContent.findIndex(
      (o) =>
        o.actualImpactContentItemId == field.actualImpactContentItemId &&
        o.idTipePekerja == field.idTipePekerja &&
        o.detailContentActualImpactId == field.detailContentActualImpactId
    );

    const newList = [...input.listDetailActualImpactContent];
    newList.splice(indexFieldInArray, 1);
    const potensi = checkPotensi(newList);
    setInput((prev) => ({
      ...prev,
      ...potensi,
      listDetailActualImpactContent: newList,
    }));
  };

  // Return functions
  const getTypeOptions = (item) => {
    if (item.detailEstimateImpactId == 1) return input.listTipePekerjaan;
    const savedTitle =
      input.actualImpactSelected.title[item.detailEstimateImpactId - 1];
    if (!savedTitle) return [];
    return input.listDetailActualImpactContentItem.filter(
      (item) =>
        item.idDataMstDtlEstimateImpactContent ==
        savedTitle.detailContentActualImpactId
    );
  };

  const getTotalReleaseProduct = (arr) => {
    if (!arr) arr = input.listDetailActualImpactContent;
    let payload = arr.find((item) => item.detailContentActualImpactId == 17);

    arr = arr.filter((item) => item.detailActualImpactId == 2);
    let total = 0;
    arr.forEach((o) => {
      total += +o.nilaiKonversi;
    });

    return { ...payload, jumlahOrNilaiKerugian: total };
  };

  const getTotalAssetAndEquipment = (arr) => {
    if (!arr) arr = input.listDetailActualImpactContent;
    let payload = arr.find((item) => item.detailContentActualImpactId == 18);

    arr = arr.filter((item) => item.detailActualImpactId == 5);
    let total = 0;
    arr.forEach((o) => {
      total += +o.jumlahOrNilaiKerugian;
    });

    return { ...payload, jumlahOrNilaiKerugian: total };
  };

  const calculateSeverityByDeathCount = (list = []) => {
    let totalDeath = 0;
    let severity;
    list.forEach((dt) => {
      if (dt.kode === "DEAD") {
        totalDeath += Number(dt.jumlahOrNilaiKerugian);
      }
    });

    if (totalDeath > 1) {
      severity = 5;
    }
    // else if (totalDeath < 2) {
    //   severity = 4;
    // }
    else {
      severity = 4;
    }

    if (severity) {
      list = list.map((dt) => {
        if (dt.kode === "DEAD") {
          dt.tingkatKeparahan = severity;
        }
        return dt;
      });
    }
    return list;
  };

  if (loading) {
    return (
      <Box sx={styles.container}>
        <h3
          style={{
            color: "black",
            textAlign: "center",
          }}
        >
          ACTUAL IMPACT
        </h3>
        <Box>
          <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
          <Box sx={styles.field}>
            <Grid container rowGap={1} columnGap={1}>
              <Grid item xl={4} lg={5} sm={12} xs={12}>
                <FormControl fullWidth>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </FormControl>
              </Grid>
              <Grid item xl={4} lg={5} sm={12} xs={12}>
                <FormControl fullWidth>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </FormControl>
              </Grid>
              <Grid item xl={3} lg={1} sm={3} xs={12}>
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
              </Grid>
            </Grid>

            <Grid container spacing={0} sx={{ mt: "15px" }}>
              <Grid item xl={3} lg={3} sm={3} xs={12}>
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
              </Grid>
              <Grid item xl={9} lg={9} sm={9} xs={12}>
                <Stack spacing={2} direction="row">
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                  <FormControl variant="standard" fullWidth>
                    <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                  </FormControl>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* SEVERITY */}
        <Box component="div" sx={{ ...styles.field, marginTop: 3 }}>
          <Grid>
            <Stack spacing={2} direction="row">
              <FormControl variant="standard" fullWidth>
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1.5rem" }} />
              </FormControl>
            </Stack>
          </Grid>
        </Box>
        {/* INVESTIGASI */}
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1 }}>
            <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            <FormControl
              sx={{ width: 200, backgroundColor: "#f5f4ff" }}
              size="small"
              disabled
            >
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </FormControl>
          </div>
          <div style={{ flex: 1 }}>
            <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            <FormControl
              disabled
              sx={{ width: 200, backgroundColor: "#f5f4ff" }}
              size="small"
            >
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </FormControl>
          </div>
        </div>
      </Box>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <h3
          style={{
            color: "black",
            textAlign: "center",
          }}
        >
          ACTUAL IMPACT
        </h3>
        {input.listDetailActualImpact.map((item) => (
          <Box key={item.detailEstimateImpactId}>
            <h4>{item.nama}</h4>

            <Box sx={styles.field}>
              <Grid container rowGap={1} columnGap={1}>
                {/* DROPDOWN SELECTION*/}
                {item.detailEstimateImpactId != 3 ? (
                  <>
                    <Grid item xl={4} lg={5} sm={12} xs={12}>
                      <FormControl fullWidth>
                        <Autocomplete
                          value={
                            input.actualImpactSelected?.title?.[
                              item.detailEstimateImpactId - 1
                            ] || null
                          }
                          onChange={(e, value) =>
                            onChangeTitle(item.detailEstimateImpactId, value)
                          }
                          required
                          getOptionLabel={(option) =>
                            option.detailContentActualImpactName
                          }
                          options={item.listContent}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={`Choose ${item.nama}`}
                            />
                          )}
                          disabled={
                            readOnly ||
                            (item.detailEstimateImpactId === 6 &&
                              input.listDetailActualImpactContent?.find(
                                (dt) => dt.detailActualImpactId === 6
                              )) ||
                            (item.detailEstimateImpactId === 4 &&
                              input.listDetailActualImpactContent?.find(
                                (dt) => dt.detailActualImpactId === 4
                              ))
                          }
                        />
                      </FormControl>
                    </Grid>
                    {/* DROPDOWN TYPE SELECTION */}
                    {item.detailEstimateImpactId == 1 ||
                    item.detailEstimateImpactId == 2 ? (
                      <Grid item xl={4} lg={5} sm={12} xs={12}>
                        <FormControl fullWidth>
                          <Autocomplete
                            value={
                              input.actualImpactSelected?.type?.[
                                item.detailEstimateImpactId - 1
                              ] || null
                            }
                            onChange={(e, value) =>
                              onChangeType(item.detailEstimateImpactId, value)
                            }
                            disabled={
                              !input.actualImpactSelected.title[
                                item.detailEstimateImpactId - 1
                              ] || readOnly
                            }
                            getOptionLabel={(option) =>
                              item.detailEstimateImpactId == 1
                                ? option.name
                                : option.itemName
                            }
                            // Show options based on selected title
                            options={getTypeOptions(item)}
                            renderInput={(params) => (
                              <TextField {...params} label="Choose type" />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    ) : null}
                  </>
                ) : null}
                {/* Button Tambah */}
                {item.detailEstimateImpactId !== 3 && (
                  <Grid item xl={3} lg={1} sm={3} xs={12}>
                    <Button
                      variant="contained"
                      sx={{ fontSize: "1.5rem", height: "100%" }}
                      onClick={() =>
                        onPressAddButton(item.detailEstimateImpactId)
                      }
                      disabled={
                        readOnly ||
                        (item.detailEstimateImpactId === 6 &&
                          input.listDetailActualImpactContent?.find(
                            (dt) => dt.detailActualImpactId === 6
                          )) ||
                        (item.detailEstimateImpactId === 4 &&
                          input.listDetailActualImpactContent?.find(
                            (dt) => dt.detailActualImpactId === 4
                          ))
                      }
                    >
                      +
                    </Button>
                  </Grid>
                )}
              </Grid>
              {/* SELECTED FIELD */}
              {input.listDetailActualImpactContent.map((field, idx) =>
                field.detailActualImpactId == item.detailEstimateImpactId ? (
                  <Grid container spacing={0} key={idx} sx={{ mt: "15px" }}>
                    {/* ID 1*/}
                    {/* ACTUAL Impact Health And Safety */}
                    {item.detailEstimateImpactId == 1 ? (
                      <>
                        <Grid item xl={3} lg={3} sm={3} xs={12}>
                          <p>{field.detailContentActualImpactName}</p>
                        </Grid>
                        <Grid item xl={9} lg={9} sm={9} xs={12}>
                          <Stack spacing={2} direction="row">
                            <TextField
                              onChange={(e) =>
                                onChangeInput(
                                  "jumlahOrNilaiKerugian",
                                  e.target.value,
                                  field
                                )
                              }
                              onWheel={disabledScrollTextBoxNumber}
                              value={field.jumlahOrNilaiKerugian || ""}
                              label="Jumlah"
                              variant="standard"
                              fullWidth
                              type="number"
                              disabled={readOnly}
                            />
                            {field.satuan ? (
                              <TextField
                                value={field.satuan || ""}
                                label="Satuan"
                                InputLabelProps={{ shrink: true }}
                                variant="standard"
                                fullWidth
                                type="text"
                                disabled
                              />
                            ) : null}
                            <FormControl variant="standard" fullWidth>
                              <TextField
                                name="tipePekerja"
                                value={field.tipePekerja || ""}
                                label="Type"
                                variant="standard"
                                fullWidth
                                disabled
                              />
                            </FormControl>
                            <TextField
                              onBlur={(e) =>
                                onChangeInput(
                                  "keterangan",
                                  e.target.value,
                                  field
                                )
                              }
                              defaultValue={field.keterangan || ""}
                              label="Keterangan"
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled={readOnly}
                            />
                            <IconButton
                              color="primary"
                              component="label"
                              onClick={() => onPressRemoveButton(field)}
                              disabled={readOnly}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                      </>
                    ) : null}

                    {/* ID 2 */}
                    {/* ACTUAL Impact ENVIRONTMENT */}
                    {item.detailEstimateImpactId == 2 ? (
                      <>
                        <Grid item xl={1} lg={1} sm={1} xs={12}>
                          <p>{field.detailContentActualImpactName}</p>
                        </Grid>
                        <Grid item xl={11} lg={11} sm={11} xs={12}>
                          <Stack spacing={2} direction="row">
                            <TextField
                              value={field.actualImpactContentItemName || ""}
                              label="Type"
                              variant="standard"
                              fullWidth
                              disabled
                            />
                            <TextField
                              name="jumlahOrNilaiKerugian"
                              onChange={(e) =>
                                onChangeInput(
                                  "jumlahOrNilaiKerugian",
                                  e.target.value,
                                  field
                                )
                              }
                              onWheel={disabledScrollTextBoxNumber}
                              value={
                                readOnly === true
                                  ? formatCurrency(
                                      parseFloat(
                                        field.jumlahOrNilaiKerugian
                                      ).toFixed(2)
                                    ) || ""
                                  : field.jumlahOrNilaiKerugian || ""
                              }
                              label="Jumlah"
                              variant="standard"
                              fullWidth
                              type="number"
                              disabled={readOnly}
                            />
                            <TextField
                              value={field.satuan || ""}
                              label="Satuan"
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled
                            />
                            <TextField
                              value={ field.konversiSatuan || "" }
                              onChange={(e) => {
                                onChangeInput(
                                  "Nilai / Satuan Volume",
                                  e.target.value,
                                  field
                                );
                              }}
                              onWheel={disabledScrollTextBoxNumber}
                              label="Nilai / Satuan Volume"
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              fullWidth
                              type="number"
                              disabled={readOnly}
                              // disabled
                            />
                            <FormControl variant="standard" fullWidth>
                              <TextField
                                value={
                                  formatCurrency(
                                    parseFloat(field.nilaiKonversi).toFixed(2)
                                  ) || ""
                                }
                                label="Hasil Konversi"
                                variant="standard"
                                fullWidth
                                disabled
                              />
                            </FormControl>
                            <TextField
                              onBlur={(e) =>
                                onChangeInput(
                                  "keterangan",
                                  e.target.value,
                                  field
                                )
                              }
                              defaultValue={field.keterangan || ""}
                              label="Keterangan"
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled={readOnly}
                            />
                            <IconButton
                              color="primary"
                              component="label"
                              onClick={() => onPressRemoveButton(field)}
                              disabled={readOnly}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                      </>
                    ) : null}

                    {/* ID 4 AND 6 */}
                    {/* ACTUAL Impact Reputation Impact And Legal, Public Notification */}
                    {item.detailEstimateImpactId == 4 ||
                    item.detailEstimateImpactId == 6 ? (
                      <>
                        <Grid item xl={3} lg={3} sm={3} xs={12}>
                          <p>{field.detailContentActualImpactName}</p>
                        </Grid>
                        <Grid item xl={9} lg={9} sm={9} xs={12}>
                          <Stack spacing={2} direction="row">
                            <TextField
                              onBlur={(e) =>
                                onChangeInput(
                                  "keterangan",
                                  e.target.value,
                                  field
                                )
                              }
                              defaultValue={field.keterangan || ""}
                              label="Keterangan"
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled={readOnly}
                            />
                            <IconButton
                              color="primary"
                              component="label"
                              onClick={() => onPressRemoveButton(field)}
                              disabled={readOnly}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                      </>
                    ) : null}

                    {/* ID 5 */}
                    {/* ACTUAL Impact Asset And Equipment */}
                    {item.detailEstimateImpactId === 5 ? (
                      <>
                        <Grid item xl={3} lg={3} sm={3} xs={12}>
                          <p>{field.detailContentActualImpactName}</p>
                        </Grid>

                        <Grid item xl={9} lg={9} sm={9} xs={12}>
                          <Stack spacing={2} direction="row">
                            <TextField
                              onChange={(e) => {
                                onChangeInput(
                                  "jumlahOrNilaiKerugian",
                                  e.target.value,
                                  field
                                );
                              }}
                              onWheel={disabledScrollTextBoxNumber}
                              value={
                                readOnly === true
                                  ? formatCurrency(
                                      parseFloat(
                                        field.jumlahOrNilaiKerugian
                                      ).toFixed(2)
                                    ) || ""
                                  : field.jumlahOrNilaiKerugian || ""
                              }
                              label="Nilai Kerugian"
                              variant="standard"
                              fullWidth
                              type="number"
                              disabled={readOnly}
                            />
                            <TextField
                              value={field.satuan || ""}
                              label="Satuan"
                              InputLabelProps={{ shrink: true }}
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled
                            />
                            <TextField
                              onBlur={(e) =>
                                onChangeInput(
                                  "keterangan",
                                  e.target.value,
                                  field
                                )
                              }
                              defaultValue={field.keterangan || ""}
                              label="Keterangan"
                              variant="standard"
                              fullWidth
                              type="text"
                              disabled={readOnly}
                            />
                            <IconButton
                              color="primary"
                              component="label"
                              onClick={() => onPressRemoveButton(field)}
                              disabled={readOnly}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                      </>
                    ) : null}
                  </Grid>
                ) : null
              )}
              {/* FOOTER ID 2 AND 5 */}
              {/* ACTUAL Impact ENVIRONTMENT, Asset And Equipment */}
              {(item.detailEstimateImpactId == 2 &&
                getTotalReleaseProduct().jumlahOrNilaiKerugian > 0) ||
              (item.detailEstimateImpactId == 5 &&
                getTotalAssetAndEquipment().jumlahOrNilaiKerugian > 0) ? (
                <Grid container spacing={0}>
                  <Grid item xl={1} lg={1} sm={1} xs={12}></Grid>
                  <Grid item xl={11} lg={11} sm={11} xs={12}>
                    <Stack spacing={2} direction="row">
                      <div style={{ width: "100%" }}></div>
                      <div style={{ width: "100%" }}></div>
                      <div style={{ width: "100%" }}></div>
                      <div style={{ width: "100%" }}></div>
                      <FormControl variant="standard" fullWidth>
                        <TextField
                          name="totalEnvKonversi"
                          value={
                            formatCurrency(
                              parseFloat(
                                item.detailEstimateImpactId == 2
                                  ? getTotalReleaseProduct()
                                      .jumlahOrNilaiKerugian
                                  : getTotalAssetAndEquipment()
                                      .jumlahOrNilaiKerugian
                              ).toFixed(2)
                            ) || ""
                          }
                          label={
                            <Typography sx={{ fontWeight: "bold" }}>
                              Total Konversi
                            </Typography>
                          }
                          variant="standard"
                          fullWidth
                          disabled
                        />
                      </FormControl>
                      <div
                        style={{
                          width: "100%",
                        }}
                      ></div>
                    </Stack>
                  </Grid>
                </Grid>
              ) : null}
              {/* ID 3 */}
              {/* ACTUAL Impact Financial Impact */}
              {item.detailEstimateImpactId == 3 ? (
                <>
                  {getTotalReleaseProduct().jumlahOrNilaiKerugian > 0 ||
                  getTotalAssetAndEquipment().jumlahOrNilaiKerugian > 0 ? (
                    <Grid
                      container
                      spacing={0}
                      sx={{ fontWeight: "bold", marginTop: -3 }}
                    >
                      Value BTR USD {formatCurrency(input.staticValueBTR)}
                    </Grid>
                  ) : null}
                  {[getTotalReleaseProduct(), getTotalAssetAndEquipment()].map(
                    (field, idx) => (
                      <Grid container spacing={0} key={idx}>
                        {field.jumlahOrNilaiKerugian > 0 ? (
                          <>
                            <Grid item xl={3} lg={3} sm={3} xs={12}>
                              <p>{field.detailContentActualImpactName}</p>
                            </Grid>
                            <Grid item xl={9} lg={9} sm={9} xs={12}>
                              <Stack spacing={2} direction="row">
                                <TextField
                                  label="Nilai Kerugian"
                                  value={
                                    formatCurrency(
                                      field.jumlahOrNilaiKerugian
                                    ) || ""
                                  }
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  disabled
                                  variant="standard"
                                  fullWidth
                                  type="text"
                                />
                                <TextField
                                  value={field.satuan || ""}
                                  disabled
                                  label="Satuan"
                                  InputLabelProps={{ shrink: true }}
                                  variant="standard"
                                  fullWidth
                                  type="text"
                                />
                                <TextField
                                  onBlur={(e) =>
                                    onChangeInput(
                                      "keterangan",
                                      e.target.value,
                                      field
                                    )
                                  }
                                  defaultValue={field.keterangan || ""}
                                  label="Keterangan"
                                  variant="standard"
                                  fullWidth
                                  type="text"
                                  disabled={readOnly}
                                />
                              </Stack>
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    )
                  )}
                  {getTotalReleaseProduct().jumlahOrNilaiKerugian > 0 ||
                  getTotalAssetAndEquipment().jumlahOrNilaiKerugian > 0 ? (
                    <Grid
                      container
                      spacing={0}
                      key={item.detailContentActualImpactId}
                    >
                      <Grid
                        item
                        xl={3}
                        lg={3}
                        sm={3}
                        xs={12}
                        sx={{ fontWeight: "bold" }}
                      >
                        Total
                      </Grid>
                      <Grid item xl={9} lg={9} sm={9} xs={12}>
                        <Stack spacing={2} direction="row">
                          <FormControl variant="standard" fullWidth>
                            <TextField
                              disabled
                              value={
                                formatCurrency(
                                  Number(
                                    getTotalReleaseProduct()
                                      .jumlahOrNilaiKerugian +
                                      getTotalAssetAndEquipment()
                                        .jumlahOrNilaiKerugian
                                  ).toFixed(0)
                                ) || ""
                              }
                              variant="standard"
                              fullWidth
                              inputProps={{
                                style: { fontWeight: "bold" },
                              }}
                            />
                          </FormControl>
                          <div style={{ width: "100%" }}></div>
                          <div
                            style={{
                              width: "100%",
                              fontWeight: "bold",
                            }}
                          >
                            Financial Impact ={" "}
                            {!input.staticValueBTR
                              ? "0"
                              : (
                                  ((getTotalReleaseProduct()
                                    .jumlahOrNilaiKerugian +
                                    getTotalAssetAndEquipment()
                                      .jumlahOrNilaiKerugian) /
                                    input.staticValueBTR) *
                                  100
                                ).toFixed(0)}
                            % BTR
                          </div>
                        </Stack>
                      </Grid>
                    </Grid>
                  ) : null}
                </>
              ) : null}
              {item.nama === "Environment" ? (
                <p style={{ color: "red" }}>
                  <small>
                    Informasi *){" "}
                    <span style={{ color: "black" }}>
                      Harap mengisi <b>Nilai / Satuan Volume</b>, sesuai dengan
                      harga yg berlaku saat kejadian dengan satuan <b>USD</b>
                    </span>
                  </small>
                </p>
              ) : (
                ""
              )}
            </Box>
          </Box>
        ))}
        {/* SEVERITY */}
        <Box component="div" sx={{ ...styles.field, marginTop: 3 }}>
          <Grid>
            <Stack spacing={2} direction="row">
              <FormControl variant="standard" fullWidth>
                <InputLabel id="idPTK">
                  Potensi Tingkat Keparahan (Severity)
                </InputLabel>
                <Select
                  labelId="idPTK"
                  id="sIdPTK"
                  label="Potensi Tingkat Keparahan (Severity)"
                  value={input.potensiTingkatKeparahan || ""}
                  disabled
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      potensiTingkatKeparahan: e.target.value,
                    }))
                  }
                >
                  {potensiTingkatKeparahanItem.map((item, idx) => (
                    <MenuItem value={item.name} key={idx}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                <p style={{ color: "red" }}>
                  <small>
                    Keterangan*){" "}
                    <span style={{ color: "black" }}>
                      Sesuai Pedoman Pengelolaan HSSE Berbasis Resiko
                    </span>
                  </small>
                </p>
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="idPK">
                  Probabilitas Kejadian (Probability)
                </InputLabel>
                <Select
                  labelId="idPK"
                  id="sIdPK"
                  label="Probabilitas Kejadian (Probability)"
                  value={input.probabilitasKejadian || ""}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      probabilitasKejadian: e.target.value,
                    }))
                  }
                  disabled={readOnly}
                >
                  {potensiKejadianItem.map((item, idx) => (
                    <MenuItem value={item.value} key={idx}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>

                <p>
                  <small>
                    <span style={{ color: "black" }}>
                      1:Rare, 2:Unlikely, 3:Moderate, 4:Likely, 5:Almost
                    </span>
                  </small>
                </p>
              </FormControl>
            </Stack>
          </Grid>
        </Box>
        {/* INVESTIGASI */}
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <FormControl sx={{ width: 250 }} size="small">
              <p>Perlu Investigasi:</p>
              <Select
                disabled
                value={input.perluDilakukanInvestigasi || false}
                displayEmpty
                inputProps={{ "aria-label": "Perlu Investigasi" }}
                sx={{ textAlign: "center", backgroundColor: "#f5f4ff" }}
              >
                <MenuItem value={true}>Ya</MenuItem>
                <MenuItem value={false}>Tidak</MenuItem>
              </Select>
            </FormControl>
            {input.tipeInsidenId == 3 ? (
              <FormControl sx={{ width: 250 }} size="small">
                <p>Process Safety Event (PSE) Level:</p>
                <Select
                  value={input.idMstPSELevel || 0}
                  inputProps={{ "aria-label": "Perlu Investigasi" }}
                  sx={{ textAlign: "center", backgroundColor: "#f5f4ff" }}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      idMstPSELevel: e.target.value,
                      mstPSELevelName: input.listPseLevel.find(
                        (i) => i.id == e.target.value
                      ).name,
                    }))
                  }
                  disabled={readOnly}
                >
                  {input.listPseLevel.map((item, idx) => (
                    <MenuItem key={idx} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
          </div>
          <div style={{ flex: 1 }}>
            <p>Pelaksana Investigasi:</p>
            <FormControl
              disabled
              sx={{ width: 250, backgroundColor: "#f5f4ff" }}
              size="small"
            >
              <Select
                value={input.pelaksanaInvestigasi || ""}
                displayEmpty
                inputProps={{ "aria-label": "Pelaksana Investigasi" }}
                sx={{ textAlign: "center" }}
                IconComponent={() => null}
                disabled
              >
                {!input.perluInvestigasi ? (
                  <MenuItem value={input.pelaksanaInvestigasi} disabled>
                    {input.pelaksanaInvestigasi}
                  </MenuItem>
                ) : null}
              </Select>
            </FormControl>
          </div>
        </div>
      </Box>
    </>
  );
};

const styles = {
  container: {
    px: 5,
    mt: 3,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
  field: {
    border: 1,
    borderColor: "lightgrey",
    px: 3,
    py: 2,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
};
export default memo(ActualImpact);
